import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../helpers/visibility'

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "paymentIdsField", "deleteButton"]

  connect() {
    this.update()
  }

  update() {
    const checked = this.checkboxTargets.filter(c => c.checked)
    const paymentIds = checked.map(c => c.value)

    this.paymentIdsFieldTarget.value = paymentIds.join(",")

    if (paymentIds.length > 0) {
      showTarget(this.deleteButtonTarget)
    } else {
      hideTarget(this.deleteButtonTarget)
    }

    // Update select-all checkbox state
    const total = this.checkboxTargets.length
    if (total > 0) {
      this.selectAllTarget.checked = checked.length === total
      this.selectAllTarget.indeterminate = checked.length > 0 && checked.length < total
    }
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(c => { c.checked = checked })
    this.update()
  }
}
